export default class ExportEntity {
    static getEntityData(elem: any) {
        return {
            uuid: elem.querySelector("#export_uuid") ? (elem.querySelector("#export_uuid") as HTMLInputElement).value : null,
        }
    }
}